/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DriverInfoDeviceType,
    DriverInfoDeviceTypeFromJSON,
    DriverInfoDeviceTypeFromJSONTyped,
    DriverInfoDeviceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface LibModelsDriverInfoDriver
 */
export interface LibModelsDriverInfoDriver {
    /**
     * 
     * @type {DriverInfoDeviceType}
     * @memberof LibModelsDriverInfoDriver
     */
    deviceType: DriverInfoDeviceType;
    /**
     * 
     * @type {string}
     * @memberof LibModelsDriverInfoDriver
     */
    driverToken: string;
    /**
     * 
     * @type {number}
     * @memberof LibModelsDriverInfoDriver
     */
    driverId?: number;
    /**
     * 
     * @type {string}
     * @memberof LibModelsDriverInfoDriver
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LibModelsDriverInfoDriver
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof LibModelsDriverInfoDriver
     */
    authType?: string;
    /**
     * 
     * @type {string}
     * @memberof LibModelsDriverInfoDriver
     */
    source?: string;
}

export function LibModelsDriverInfoDriverFromJSON(json: any): LibModelsDriverInfoDriver {
    return LibModelsDriverInfoDriverFromJSONTyped(json, false);
}

export function LibModelsDriverInfoDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): LibModelsDriverInfoDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceType': DriverInfoDeviceTypeFromJSON(json['device_type']),
        'driverToken': json['driver_token'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
        'authType': !exists(json, 'auth_type') ? undefined : json['auth_type'],
        'source': !exists(json, 'source') ? undefined : json['source'],
    };
}

export function LibModelsDriverInfoDriverToJSON(value?: LibModelsDriverInfoDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device_type': DriverInfoDeviceTypeToJSON(value.deviceType),
        'driver_token': value.driverToken,
        'driver_id': value.driverId,
        'name': value.name,
        'surname': value.surname,
        'auth_type': value.authType,
        'source': value.source,
    };
}


